import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PIXI} from '@colonist/pixi'
import {ACTIVE_OPACITY} from '../../ui_utils/Utils'
import {UIGamePopupSelectDiceContainer} from './UIGamePopupSelectDiceContainer'

export class UIGamePopupSelectDiceView extends SpriteView {
    private readonly diceSelectContainer: UIGamePopupSelectDiceContainer
    private readonly selectionMarker: SpriteView
    readonly diceNumber: number
    private readonly inactiveOpacityNumber: number
    private _selected: boolean

    constructor(diceSelectContainer: UIGamePopupSelectDiceContainer, diceNumber: number, x: number, y: number, size: number, clickAction: () => void, container: PIXI.Container, redDice: boolean) {
        const diceTexture = UIGameSpriteHandler.getDiceImage(diceNumber, redDice)
        super(x, y, size, size, container, diceTexture)
        this.diceSelectContainer = diceSelectContainer
        this.diceNumber = diceNumber
        this.inactiveOpacityNumber = 0.5
        this.selected = false

        container.addChild(this)
        this.centerYInParent()
        this.inactiveOpacity()

        const markerTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.dice_marker)
        const markerSize = size * 1.05
        const padding = (markerSize - size) / 2
        this.selectionMarker = new SpriteView(this.x - padding, this.y - padding, markerSize, markerSize, container, markerTexture)
        this.hideSelectionMarker()

        const clickedDice = () => {
            this.diceSelectContainer.resetAllDice()
            this.selected = true
            clickAction()
        }
        this.setClickAction(clickedDice)

        this.setHover()
    }

    private setHover() {
        const pointerover = () => {
            this.activeOpacity()
        }
        const pointerout = () => {
            this.inactiveOpacity()
        }
        this.setHoverAction(pointerover, pointerout)
    }

    get selected(): boolean {
        return this._selected
    }

    set selected(newValue: boolean) {
        this._selected = newValue
        this.inactiveOpacity()
        if(!newValue) return
        this.activeOpacity()
        this.showSelectionMarker()
    }

    private activeOpacity() {
        this.alpha = ACTIVE_OPACITY
    }

    private inactiveOpacity() {
        if(this.selected) return
        this.alpha = this.inactiveOpacityNumber
    }

    private hideSelectionMarker() {
        if(this.selectionMarker.parent == undefined) return
        this.selectionMarker.parent.removeChild(this.selectionMarker)
    }

    private showSelectionMarker() {
        if(this.selectionMarker.parent != undefined) return
        if(this.parent == undefined) return
        this.parent.addChild(this.selectionMarker)
    }

    forceResetOpacity() {
        this.selected = false
        this.hideSelectionMarker()
    }
}
